import { meta } from "../library/dataService";
import { Box } from "@mui/material";
import { Fragment } from "react";
import { BorderOverlay } from "./NGDesignOverlay";
import { syncOverlay } from "../library/syncOverlay";

const HandleOverlay = ({ rect, style }) => {
  const handleStyle = {
    position: "absolute",
    background: "var(--editor-select-color)",
    display: "flex",
    left: `${rect.left}px`,
    top: `${rect.top - 16}px`,
    width: `5px`,
    height: "16px",
    color: "white",
    lineHeight: "16px",
    fontSize: "12px",
    padding: "0 2px",
    pointerEvents: "auto",
    cursor: "move",
    gap: "0.5rem",
    ...style,
  };

  const reorderStyle = { cursor: "pointer" };

  return (
    <Box sx={handleStyle}>
      <span style={reorderStyle}></span>
    </Box>
  );
};

export default function NGSyncOverlay({ Users, SyncId, OverlayCollection }: any) {
  const collection = OverlayCollection.peek();
  const keys = Object.keys(collection);
  function createBorderOverlay(target: any, id: any, node: any, sessionId: string): any {
    const syncId = SyncId.peek();
    const bounds = target?.getBoundingClientRect();

    const rect = {
      left: bounds?.left + window.scrollX,
      top: bounds?.top + window.scrollY,
      width: bounds?.width,
      height: bounds?.height,
    };
    const status = "hovered";

    const u = Users.peek();
    const userIndex = u.findIndex((item) => item.Id === sessionId);
    if (userIndex < 0) return;
    let color = u[userIndex]?.Color;
    const style = {
      border: `solid 1px ${color}`,
    };

    let index = 0;
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (key === sessionId) break;
      if (!u.some((user) => user.Id === key)) continue;
      if (collection[key].id === id && collection[key].syncId === syncId) index++;
    }

    return {
      type: "border",
      id,
      rect,
      style,
      status,
      node,
      sessionId,
      color,
      index,
      ["data-testid"]: `sync-overlay-${sessionId}`,
    };
  }

  function generateOverlays(collection) {
    const overlays: any = [];

    keys.forEach((sessionId) => {
      const { id, syncId } = collection[sessionId];

      if (!id) return;
      if (syncId && SyncId.peek() !== syncId) return;
      const target = document.querySelector(`[data-testid="${id}"]`);
      let node = meta.getNode(syncOverlay.cleanId(id));

      const parentTestId = target?.parentElement?.getAttribute("data-testid");
      if (parentTestId) {
        const newId = id.replace(`${parentTestId}-`, "");
        node = meta.getNode(newId);
      }

      const newOverlay = createBorderOverlay(target, id, node, sessionId);
      if (newOverlay) {
        overlays.push(newOverlay);
      }
    });

    return overlays;
  }

  const overlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 1000,
    width: "100%",
    height: "100vh",
    pointerEvents: "none",
    marginLeft: "0px !important",
  };

  return (
    <>
      <Box sx={overlayStyle} data-testid="sync-overlay-container">
        {generateOverlays(OverlayCollection.value).map((o, i) => {
          if (!o) return;
          return (
            <div key={i} data-testid={o["data-testid"]}>
              <BorderOverlay {...o} data-testid={o["data-testid"]} />
              <HandleOverlay
                key={o.sessionId}
                rect={o.rect}
                style={{ left: `${o.rect.left + o.index * 5}px`, background: o.color }}
              />
            </div>
          );
        })}
      </Box>
    </>
  );
}
